/* eslint-disable */
import 'core-js/stable';
import './styles/index.scss';

import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { IntlProvider } from 'react-intl';
import App from 'containers/App';
import store from 'store';
import history from 'store/history';
import Api from 'lib/api';
import { actions as userActions } from 'modules/user';

let pendingRefresh = null;

Api.setOnTokenExpired(async () => {
  if (!pendingRefresh) {
    pendingRefresh = store.dispatch(userActions.refreshToken()).finally(() => {
      pendingRefresh = null;
    });
  }
  await pendingRefresh;

  const newToken = store.getState().user.authToken;

  // If the user is on a product page, verify they still own it after the refresh
  const pathParts = history.location.pathname.split('/');
  const slug = pathParts[1] === 'products' && pathParts[2];
  if (newToken && slug) {
    await store.dispatch(userActions.getUserProducts());
    const owned = store.getState().user.products.some(p => p.slug === slug);
    if (!owned) {
      history.push('/products/');
    }
  }

  return newToken;
});

//import '@frn/amityco-ui-kit-open-source/dist/index.css';

window.urlsCache = {};

const locale = (navigator.language || 'en').split('-')[0];

const renderApp = Component => {
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <IntlProvider locale={locale} defaultLocale="en" messages={{}}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Component />
        </ConnectedRouter>
      </Provider>
    </IntlProvider>
  );
};

renderApp(App);
/* eslint-disable */
// Hot Module Replacement API
/*
if (module.hot) {
  module.hot.accept('containers/App', () => renderApp(App));
}
*/
